import { PartnerType } from '@/lib/types';
import { styled } from '@mui/material/styles';
import { PartnerTypes } from '@/constants/PartnerTypes';

const PartnerBadge = ({ type }: { type?: PartnerType }) => {
  const PartnerElements = PartnerTypes?.[type || 'lead'];

  return (
    <Root type={type}>
      {PartnerElements?.icon}
      {PartnerElements?.label}
    </Root>
  );
};

const Root = styled('div')<{ type?: PartnerType }>(
  ({ theme, type }) => {
    let background = theme.palette.primary.main;

    if (type === 'operator') {
      background = theme.palette.red500;
    } else if (type === 'brand') {
      background = theme.palette.red300;
    } else if (type === 'lead') {
      background = theme.palette.grey800;
    } else if (type === 'platform') {
      background = theme.palette.primary.main;
    }

    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
      width: 'fit-content',
      minWidth: 88,
      height: 24,
      background,
      color: theme.palette.common.white,
      fontSize: 10,
      fontWeight: 600,
      lineHeight: '12px',
      borderRadius: theme.radii.md,

      svg: {
        width: 16,
        height: 16,
      },

      path: {
        stroke: theme.palette.common.white,
      },
    };
  },
);

export default PartnerBadge;
